import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LayoutService implements OnDestroy {

    public sideNav = new EventEmitter<any>();

    toggleSideNav() {
        this.sideNav.emit();
    }

    getSideNav() {
        return this.sideNav;
    }

    ngOnDestroy(): void {
        this.sideNav?.unsubscribe();
    }
}
